import type { ComponentProps } from 'react';
import { createRoot } from 'react-dom/client';
import { readPageProps } from '../lib/page-props';
import { OAuthPage } from '../pages/OAuthPage';

const props = readPageProps<ComponentProps<typeof OAuthPage>>();

createRoot(document.getElementById('root')!).render(<OAuthPage {...props} />);
